import { render } from "./RegistroLecheFria.vue?vue&type=template&id=7dbc35e7"
import script from "./RegistroLecheFria.vue?vue&type=script&lang=js"
export * from "./RegistroLecheFria.vue?vue&type=script&lang=js"

import "./RegistroLecheFria.vue?vue&type=style&index=0&id=7dbc35e7&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__